<template>
  <div
    class="page_container userPage"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/mine' }">我的</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/companyIndex/companyUserList` }"
          >合作商家管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ userInfo.truename }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="form_container">
      <div class="content_wrap flex-between">
        <div class="user_intro">
          <div class="block flex-rowl logo_tit">
            <div class="logo flex-rowc">
              <el-image :src="userInfo.headimg" fit="contain">
                <div slot="error" class="image-slot flex-rowc">
                  <i class="iconfont icon-zanwutupian1"></i>
                </div>
              </el-image>
            </div>
            <div class="content">
              <!-- <p>
                昵称：
                <span>{{ userInfo.nickname ? userInfo.nickname : "" }}</span>
              </p> -->

              <!-- <p>
                <span
                  >{{ userInfo.levelid ? "LV-" + userInfo.levelid : "" }} |
                  {{ userInfo.attrname ? userInfo.attrname : "" }}</span
                >
              </p> -->
              <!-- <p>
                ID：
                <span>{{ userInfo.accountid ? userInfo.accountid : "" }}</span>
              </p> -->
            </div>
          </div>
          <div class="block">
            <p>
              姓名：
              <span>{{ userInfo.truename ? userInfo.truename : "" }}</span>
            </p>
            <p>
              工作手机：<span>{{
                tuozhan.mobile2 ? tuozhan.mobile2 : ""
              }}</span>
            </p>
            <p>
              工作微信：<span>{{ tuozhan.weixin ? tuozhan.weixin : "" }}</span>
            </p>
            <p>
              性别：<span>{{ userInfo.sex ? userInfo.sex : "" }}</span>
            </p>
            <p>
              年龄：<span>{{ userInfo.age ? userInfo.age : "" }}</span>
            </p>
          </div>
          <div class="block">
            <p>
              所在地区：<span>{{ PCA_address }}</span>
            </p>
            <p>
              详细地址：<span>{{ userInfo.addr }}</span>
            </p>
          </div>
          <div class="block">
            <p>是否允许合作快速发布商品</p>
            <el-radio-group v-model="isquick">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="user_operation flex-cowl" v-if="isShow">
          <div
            class="apply_operation_wrap"
            v-if="cooperationQy.checkstate != 1"
          >
            <div class="content">
              <div class="txt1">申请加入时间：</div>
              <div class="txt2">
                {{ cooperationQy.askdate | formatDate }}
              </div>
            </div>
            <div class="primary-button" @click="handleAgree">同意加入申请</div>
            <div class="primary-button-plain" @click="handleRefuse">
              拒绝加入申请
            </div>
          </div>
          <div
            class="primary-button-plain"
            @click="handleRemove"
            v-if="cooperationQy.checkstate == 1"
          >
            解除合作关系 <i class="iconfont icon-guanbi"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleRetuen">←返回</div>
    </div>
  </div>
</template>
<script>
import { encryptstringview } from "../../api/api";
import {
  refuseCooperationQy,
  agreeCooperationQy,
  removeCooperationQy,
  getCooperationQyDetail,
  updateIsquick
} from "../../api/company";
export default {
  name: "companyUserDetail",
  data() {
    return {
      loading: false,
      isShow: false,
      department: "",
      departmentId: "",
      departList: [],
      role: "",
      roleId: "",

      PCA_address: "", // 省、市、区
      userInfo: "",
      tuozhan: "",
      works: "",
      qy: "",

      id: "", // 用户id
      openid: "", // 用户openid
      cooperationQy: "", // 合作商家
      isquick: '0',  // 是否允许快速发布商品 1=允许 0允许
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { openid, id } = JSON.parse(res.jsondata);
        this.id = id;
        this.openid = openid;
        this.getCooperationQyDetail();
      } else {
        this.$router.back();
      }
    },

    // 获取
    getCooperationQyDetail() {
      this.loading = true;
      getCooperationQyDetail({ id: this.id }).then((res) => {
        this.cooperationQy = res;
        this.loading = false;

        let newUser = res.user;
        this.userInfo = newUser;
        this.PCA_address =
          (newUser.provincename ? newUser.provincename : "") +
          " " +
          (newUser.cityname ? newUser.cityname : "") +
          " " +
          (newUser.areaname ? newUser.areaname : "");
        this.tuozhan = newUser.ext ? newUser.ext : "";
        this.works =
          newUser.ams_farming_user_works.length == 0
            ? ""
            : newUser.ams_farming_user_works[0][0];
        this.qy = newUser.qy;
        this.department = newUser.deptname;
        this.departmentId = newUser.deptid;
        this.role = newUser.rolename;
        this.roleId = newUser.roleid;
        this.isquick = res.isquick ? res.isquick : '0';

        this.isShow = true;
      });
    },

    // 同意
    handleAgree() {
      let { id, openid, cooperationQy } = this;
      this.loading = true;
      agreeCooperationQy({
        id,
        openid,
        qyid: cooperationQy.qyid,
        checkstate: 1,
      }).then((res) => {
        if (res.result) {
          this.loading = false;
          this.$message.success(res.message);
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          this.$message.error(res.message || "服务器报错，请稍后～");
          this.loading = false;
        }
      });
    },

    // 拒绝
    handleRefuse() {
      let { id, openid, cooperationQy } = this;
      this.loading = true;
      refuseCooperationQy({
        id,
        openid,
        qyid: cooperationQy.qyid,
        checkstate: 2,
      }).then((res) => {
        if (res.result) {
          this.loading = false;
          this.$message.success(res.message);
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          this.$message.error(res.message || "服务器报错，请稍后～");
          this.loading = false;
        }
      });
    },

    // 移出企业
    handleRemove() {
      this.$message.warning("即将开放");
      // this.$confirm("是否确定移出该合作商家", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      // })
      //   .then(() => {
      //     this.removeCooperationQy();
      //   })
      //   .catch(() => {});
    },
    removeCooperationQy() {
      this.loading = true;
      removeCooperationQy({ id: this.id }).then((res) => {
        if (res.result) {
          this.loading = false;
          this.$message.success(res.message);
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          this.$message.error(res.message || "服务器报错，请稍后～");
          this.loading = false;
        }
      });
    },

    query() {
       let { id, openid, cooperationQy, isquick } = this;
      this.loading = true;
      updateIsquick({
        id,
        openid,
        qyid: cooperationQy.qyid,
        isquick,
      }).then(res => {
        if (res.result) {
          this.loading = false;
          this.$message.success(res.message);
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          this.$message.error(res.message || "服务器报错，请稍后～");
          this.loading = false;
        }
      })
    },

    // 返回上一页
    handleRetuen() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.userPage {
  .user_intro {
    width: 48%;
    flex-shrink: 0;
    margin-right: 5%;
    .block {
      margin-bottom: 25px;
    }
    p {
      color: #404d6c;
    }
    .logo_tit {
      align-items: flex-start;
      .logo {
        width: 100px;
        height: 100px;
        margin-right: 20px;
        background: #fff;
        .icon-zanwutupian1 {
          font-size: 40px;
        }
      }
    }
  }
  .user_operation {
    flex: 1;
    font-size: 18px;
    color: #444;
    .apply_operation_wrap {
      .txt1 {
        margin-bottom: 10px;
      }
      .primary-button {
        margin: 30px 0 20px;
      }
    }
    .other_wrap {
      .depar_role_wrap {
        .tit {
          margin-bottom: 20px;
        }
        .primary-button {
          margin: 30px 0 20px;
        }
        .el-select {
          width: 100%;
        }
      }
    }
  }
}
</style>